import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  imports: [MatSlideToggleModule],
})
export class SlideToggleComponent {
  @Output() toggleClicked = new EventEmitter<any>();
  @Input() checked = false;
  @Input() param: any;

  constructor() {}
  handleClick(event: Event) {
    this.toggleClicked.emit({ event, param: this.param });
  }
}
